export default __webpack_public_path__ + "static/media/Imageeight.3e435631.jpeg";